// frontend_react/src/pages/ComingSoonPage.jsx

import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.text};
`;

const Message = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.colors.text};
`;

const HomeLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export default function ComingSoonPage() {
  return (
    <PageWrapper>
      <Title>Le MarketPlace est en phase de développement</Title>
      <Message>Nous travaillons activement pour vous proposer très bientôt le MarketPlace.</Message>
      <HomeLink to="/">Retourner à l’accueil</HomeLink>
    </PageWrapper>
  );
}
